<template>
    <div class="uh-portal">
      <div v-if="!iframesEnabled || !cardsEnabled" class="text-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div v-if="iframesEnabled">
        <iframe v-for="domain in domains" :ref="domain.site_domain" :src="uriScheme + domain.site_domain" @load="IframeOnload" style="display: none;"></iframe>   <!-- // ":src" is the shorthand for "v-bind:src" -->
      </div>
      <div v-if="cardsEnabled">
        <div class="pb-1 text-right">
          <span class="btn">{{ signedInAs }}</span>
          <button v-on:click="Logout" type="button" class="btn btn-light">Sign out</button>
        </div>
        <div class="row">
          <div v-for="domain in domains" class="col-sm-3 py-2">
            <div class="card h-100">
              <div class="card-body d-flex flex-column">
                <h5 class="card-title">{{ domain.site_name }}</h5>
                <p class="card-text">{{ domain.site_desc }}</p>
                <a :href="uriScheme + domain.site_domain" target="_blank" class="card-link mt-auto">Open link in new tab</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import { GetUser, SetUser } from '../token';

  export default {
    data () {
      return {
        signedInAs: '',
        uriScheme: 'https://',
        domains: [],
        domainsBeingSetWithCookies: [],
        domainsSetWithCookies: [],
        onloadIframes: [],
        iframesEnabled: false,
        cardsEnabled: false
      }
    },
    computed: {
    },
    watch: {
      /** watch domainsBeingSetWithCookies */
      domainsBeingSetWithCookies: function () {
        // console.log(new Date().getTime(), "domainsBeingSetWithCookies:", this.domainsBeingSetWithCookies.length);
      },
      /** watch domainsSetWithCookies */
      domainsSetWithCookies: function () {
        // console.log(new Date().getTime(), "domainsSetWithCookies:", this.domainsSetWithCookies.length);

        /** Sometimes some iframes still have valid cookies even though it is beyond 24 hours. */
        /** This is why the number of domains need cookies may not equal to the total number of domains. */
        if (this.domainsSetWithCookies.length == this.domainsBeingSetWithCookies.length) {
          if (this.$route.query.redirect_uri) {
            // console.log(new Date().getTime(), "Redirecting to:", this.$route.query.redirect_uri);
            setTimeout(this.RedirectTo, 0, this.$route.query.redirect_uri);
          } else {
            this.cardsEnabled = true;
          }
        }
        // console.log(new Date().getTime(), "cardsEnabled:", this.cardsEnabled);
        // console.log(new Date().getTime(), "redirect_uri:", this.$route.query.redirect_uri);
      },
      /** watch onloadIframes */
      onloadIframes: function () {
        // console.log(new Date().getTime(), "onloadIframes:", this.onloadIframes.length);

        /** Sometimes some iframes still have valid cookies even though it is beyond 24 hours. */
        /** If no iframe needs cookies, the number of iframes loaded must be equal to the total number of domains. */
        if (this.domainsBeingSetWithCookies.length == 0 && this.onloadIframes.length == this.domains.length) {
          if (this.$route.query.redirect_uri) {
            // console.log(new Date().getTime(), "Redirecting to:", this.$route.query.redirect_uri);
            setTimeout(this.RedirectTo, 0, this.$route.query.redirect_uri);
          } else {
            this.cardsEnabled = true;
          }
        }
        // console.log(new Date().getTime(), "cardsEnabled:", this.cardsEnabled);
        // console.log(new Date().getTime(), "redirect_uri:", this.$route.query.redirect_uri);
      },
    },
    created() {
    },
    mounted() {
      let savedUser = GetUser();
      // console.log(new Date().getTime(), "Portal GetUser():", savedUser);
      if(savedUser == null) {
        this.$router.replace({ name: "login" });
      } else if (Date.now() > Date.parse(savedUser['token timestamp utc']) + (24 * 60 * 60 * 1000)) {
        // console.log(new Date().getTime(), "Date.now():", Date.now());
        // console.log(new Date().getTime(), "token timestamp utc + 24 hours:", Date.now() > Date.parse(savedUser['token timestamp utc']) + (24 * 60 * 60 * 1000));
        this.$router.replace({ name: "login" });
      } else {
        const uri = 'https://uws3pl8bql.execute-api.ap-southeast-2.amazonaws.com/dev/sign-in/token';
        this.$http.post(uri, {
          "token": savedUser.token
        })
        .then((response) => {
          // console.log('Respose:', response)
          // console.log('Status:', response.status)
          // console.log(new Date().getTime(), 'User ID:', response.data);
          if (savedUser.ID == response.data.user_id) {
            this.GetDomainsWithSignedCookies(savedUser.ID);
            this.signedInAs = savedUser['full name'];
          } else {
            this.$router.replace({ name: "login" });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$router.replace({ name: "login" });
        });
      }
    },
    methods: {
      RedirectTo(redirect_uri) {
        // console.log(new Date().getTime(), "redirect_uri:", redirect_uri);
        window.location.replace(redirect_uri);
        // window.location.href = redirect_uri;
      },
      EnableIframes() {
        this.iframesEnabled = true;
        // console.log(new Date().getTime(), "this.iframesEnabled:", true);
      },
      AddIframeListener() {
        /** Add event listener */
        // /** Can do it via window.onmessage BUT SendIframeCookies and ParseOriginToRef methods could NOT be recognised */
        // window.onmessage = function(e) {
        //   console.log(e);
        //   if (e.data == 'loaded') {
        //     this.SendIframeCookies(this.ParseOriginToRef(e.origin));   // TypeError: this.ParseOriginToRef is not a function
        //   }
        // };
        window.addEventListener('message', this.HandleMessage);
        // console.log(new Date().getTime(), 'addEventListener: HandleMessage()');
      },
      // CreateInvalidatingIframes(domain) {
      //   // console.log(new Date().getTime(), "domain:", domain);
      //   let ifr = document.createElement('iframe');
      //   ifr.name = ifr.id = 'ifr_' + Date.now();
      //   // console.log(new Date().getTime(), "ifr.name:", ifr.name);
      //   ifr.style.display = 'none';
      //   document.body.appendChild(ifr);
      //   let form = document.createElement('form');
      //   form.method = "POST";
      //   form.target = ifr.name;
      //   form.action = 'https://' + domain + '/';
      //   document.body.appendChild(form);
      //   form.submit();
      // },
      InvalidateNavigationCache() {
        // for (var i = 0; i < this.domains.length; i++) {
        //   // console.log(new Date().getTime(), 'InvalidateNavigationCache domain:', this.domains[i].site_domain);
        //   this.CreateInvalidatingIframes(this.domains[i].site_domain);
        // }

        setTimeout(this.AddIframeListener, 0);

        setTimeout(this.EnableIframes, 1000);
      },
      AddToOnloadIframes(reference) {
        // console.log(new Date().getTime(), reference);
        if(this.onloadIframes.indexOf(reference) == -1) {
          // console.log(new Date().getTime(), reference + ' added to onloadIframes.');
          this.onloadIframes.push(reference);
        }
      },
      IframeOnload(event) {
        // console.log("IframeOnload:", event);

        let frame = event.currentTarget;
        // console.log(new Date().getTime(), "IframeOnload:", frame);
        // console.log(new Date().getTime(), "IframeOnload:", frame.src);

        /** Wait 1000 milliseconds and add iframes to onloadIframes. */
        setTimeout(this.AddToOnloadIframes, 1000, this.ParseOriginToRef(frame.src));

        // console.log(frame.contentDocument);
        // console.log(frame.contentWindow);
      },
      // ClearLocalExistingCookies() {
      //   document.cookie = "CloudFront-Key-Pair-Id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      //   document.cookie = "CloudFront-Policy=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      //   document.cookie = "CloudFront-Signature=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      //   console.log("document.cookie:", document.cookie);
      // },
      // GetLocalCookie(cname) {
      //   var name = cname + "=";
      //   var ca = document.cookie.split(';');
      //   for(var i = 0; i < ca.length; i++) {
      //     var c = ca[i];
      //     while (c.charAt(0) == ' ') {
      //       c = c.substring(1);
      //     }
      //     if (c.indexOf(name) == 0) {
      //       return c.substring(name.length, c.length);
      //     }
      //   }
      //   return "";
      // },
      GetDomainsWithSignedCookies(userid) {
        const customHeaders = {
          'Content-Type': 'application/json',
          'X-Api-Key': 'J3fSK1eQeT7R0sawW5nhKNF7aprjJVs7j2pTIbKg'
        }

        const uri = 'https://d2vhimflpi.execute-api.ap-southeast-2.amazonaws.com/dev/cookies';

        this.$http.post(uri, {
          "user_id": userid.toString()
        }, { headers: customHeaders
        })
        .then((response) => {
            // console.log('Respose:', response);
            // console.log('Status:', response.status);
            // console.log(new Date().getTime(), 'Domains & signed cookies:', response.data);
            this.domains = response.data;
            // this.iframesEnabled = true;
            this.InvalidateNavigationCache();
        })
        .catch((error) => {
            console.log(error);
            this.GetDomainsWithSignedCookies(userid);
        });
      },
      ParseOriginToRef(origin) {
        // console.log(new Date().getTime(), 'ParseOriginToRef:', origin.split('//')[1].split('/')[0]);
        return origin.split('//')[1].split('/')[0];
      },
      SendSignedInUsername(reference) {
        // console.log(new Date().getTime(), 'this.signedInAs:', this.signedInAs);
        let frame = this.$refs[reference][0];
        frame.contentWindow.postMessage(this.signedInAs, '*');
      },
      SendIframeCookies(reference) {
        // console.log(new Date().getTime(), 'SendIframeCookies:', reference);

        let frame = this.$refs[reference][0];
        // console.log(new Date().getTime(), 'SendIframeCookies:', frame);
        // console.log('SendIframeCookies: ', frame.contentDocument);
        // console.log('SendIframeCookies: ', frame.contentWindow);

        let cookieArray = [];
        for (var i = 0; i < this.domains.length; i++) {
          if (this.domains[i].site_domain == reference) {
            // console.log(new Date().getTime(), 'Cookie found: ' + this.domains[i].site_domain);
            cookieArray = this.domains[i].signed_cookies;
          }
        }

        frame.contentWindow.postMessage(JSON.stringify(cookieArray), '*');
      },
      AddToDomainsBeingSetWithCookies(reference) {
        // console.log(new Date().getTime(), reference);
        if(this.domainsBeingSetWithCookies.indexOf(reference) == -1) {
          // console.log(new Date().getTime(), reference + ' cookies being set.');
          this.domainsBeingSetWithCookies.push(reference);
        }
      },
      AddToDomainsSetWithCookies(reference) {
        // console.log(new Date().getTime(), reference);
        if(this.domainsSetWithCookies.indexOf(reference) == -1) {
          // console.log(new Date().getTime(), reference + ' cookies set.');
          this.domainsSetWithCookies.push(reference);
        }
      },
      HandleMessage(event) {
        // console.log(new Date().getTime(), event);
        switch (event.data) {
          case 'loaded':
            setTimeout(this.AddToDomainsBeingSetWithCookies, 0, this.ParseOriginToRef(event.origin));
            setTimeout(this.SendSignedInUsername, 100, this.ParseOriginToRef(event.origin));
            setTimeout(this.SendIframeCookies, 500, this.ParseOriginToRef(event.origin));
            break;
          case 'reloaded':
            setTimeout(this.AddToDomainsSetWithCookies, 1000, this.ParseOriginToRef(event.origin));
            break;
        }
      },
      Logout() {
        SetUser(null);
        this.$router.replace({ name: "login" });
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Portal.vue